import request from '@/utils/requestHome'

export function getAllianceList (data) {
  return request({
    url: '/union/list',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/alliance.js